module.exports = __webpack_public_path__ + "img/right-arrow1.932f9a91.svg";